export default __webpack_public_path__ + "static/good-reads-87f1b7a620c6f0aaf42def8ed0518971.png";